import React from 'react';
import '../CookiePolicy/CookiePolicy.css';

const CookiePolicy = () => {
  return (
    <div className="cookie-container">
      <h1 className="cookie-title">Cookie Policy</h1>
      <p className="cookie-effective-date">Effective Date: May 24, 2025</p>

      <p className="cookie-intro">
        HomeCookt.com uses cookies to make your experience smoother, faster, and more personal.
      </p>

      <section className="cookie-section">
        <h2 className="cookie-section-title">What we collect:</h2>
        <div className="cookie-content">
          <ul>
            <li>Device and browser information</li>
            <li>Location (if you allow it)</li>
            <li>Preferences (like your favourite cooks or meals)</li>
            <li>Anonymous usage data</li>
          </ul>
        </div>
      </section>

      <section className="cookie-section">
        <h2 className="cookie-section-title">Your Data</h2>
        <div className="cookie-content">
          <p>We do not sell your data or track you across the internet.</p>
          <p>By using HomeCookt, you agree to the use of cookies for things like saving your login, remembering your orders, and improving performance.</p>
        </div>
      </section>

      <section className="cookie-section">
        <h2 className="cookie-section-title">Your Control</h2>
        <div className="cookie-content">
          <p>You can clear or block cookies anytime in your browser settings.</p>
        </div>
      </section>
    </div>
  );
};

export default CookiePolicy;
